import { CheckCircle2 } from "lucide-react";

const items = [
  "Atendimento rápido",
  "Equipamentos para diferentes tipos de veículos",
  "Reboque Asa Delta",
  "Reboque Plataforma",
  "Atendimento para motos",
  "Atendimento para veículos leves e utilitários",
  "Comunicação direta pelo WhatsApp",
  "Atendimento regional",
];

export default function Differentials() {
  return (
    <section id="diferenciais" className="bg-[#111111] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <p className="text-[#50CF08] uppercase tracking-widest text-sm font-semibold">Diferenciais</p>
        <h2 className="font-bebas text-4xl md:text-6xl uppercase tracking-tight text-[#FEFB0E] mt-2">
          Por que chamar a Brasil Transportes
        </h2>
        <ul className="mt-12 grid sm:grid-cols-2 gap-x-10 gap-y-5 max-w-4xl">
          {items.map((item) => (
            <li
              key={item}
              data-testid={`differential-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex items-start gap-3 text-base md:text-lg text-neutral-200"
            >
              <CheckCircle2 className="w-6 h-6 text-[#50CF08] shrink-0 mt-0.5" />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
